class AppRouting {
  constructor(appSession, appSessionCapabilities) {
    'inject';

    this._appSession = appSession;
    this._appSessionCapabilities = appSessionCapabilities;
    this._routesDefaultSettings = {
      requiresAnonymous: false,
      requiresAuthorization: true,
      requiresPermissions: [],
      requiresSwitchAccountEnabled: false,
    };
  }
  validate(
    routeSettings = {},
    authenticationRoute = 'login',
    fallbackRoute = 'home',
  ) {
    const result = {
      allowed: false,
      denied: true,
      redirectTo: '',
    };

    const newSettings = Object.assign({}, routeSettings);
    Object.keys(this._routesDefaultSettings).forEach((settingName) => {
      if (typeof newSettings[settingName] === 'undefined') {
        newSettings[settingName] = this._routesDefaultSettings[settingName];
      }
    });

    if (newSettings.requiresAnonymous) {
      newSettings.requiresAuthorization = false;
      newSettings.requiresPermissions = [];
    } else if (newSettings.requiresAuthorization) {
      newSettings.requiresAnonymous = false;
    }

    const isAuthenticated = this._appSession.isAuthenticated();
    if (newSettings.requiresAuthorization && !isAuthenticated) {
      result.redirectTo = authenticationRoute;
    } else if (
      (newSettings.requiresAnonymous && isAuthenticated) ||
      (
        newSettings.requiresPermissions &&
        !this._appSessionCapabilities.hasRoutePermissions(newSettings.requiresPermissions)
      ) ||
      (newSettings.requiresSwitchAccountEnabled && !this._appSession.canSwitchAccount())
    ) {
      result.redirectTo = fallbackRoute;
    } else {
      result.allowed = true;
    }

    result.denied = !result.allowed;
    return result;
  }
  extractRoutes(definition) {
    return Object.keys(definition)
    .map((key) => this._getRoutesFromList(definition[key]))
    .reduce((currentList, list) => [...currentList, ...list], []);
  }
  _getRoutesFromList(list) {
    const result = [];
    list.forEach((route) => {
      const newRoute = Object.assign({}, route);
      const { items } = newRoute;
      delete newRoute.items;
      result.push(newRoute);
      if (items && items.length) {
        result.push(...this._getRoutesFromList(items));
      }
    });

    return result;
  }
}

export { AppRouting };
